export const FIELD_TYPES = {
    STRING: 'string',
    CHOICE: 'choice',
    MULTIPLE_CHOICE: 'multiple_choice',
    BOOL: 'bool',
    FLOAT: 'float',
    DATE: 'date',
    URL: 'url',
};

const OPEN_LIST_TARGETS = ['gender', 'color', 'size'];
const NUMBER = /^-?\d+([.,]\d+)?$/;
const DATE = /^\d{4}-\d{2}-\d{2}$/;

/**
 * How a target is edited, from GET /enrichment/values: gender, color and size are lists
 * that also show a computed value outside the referential; any other attribute comes
 * with its type, its options and the maximum of choices.
 */
export function fieldFor(catalog, target) {
    if (OPEN_LIST_TARGETS.includes(target)) {
        return {type: FIELD_TYPES.CHOICE, label: null, options: catalog[target] ?? [], max: 1, openList: true};
    }

    const attribute = catalog.attributes?.[target];

    return {
        type: attribute?.type ?? FIELD_TYPES.STRING,
        label: attribute?.label ?? null,
        options: attribute?.options ?? [],
        max: attribute?.max ?? null,
        openList: false,
    };
}

function isDate(text) {
    if (!DATE.test(text)) {
        return false;
    }
    const date = new Date(`${text}T00:00:00Z`);

    return !Number.isNaN(date.getTime()) && date.toISOString().startsWith(text);
}

function isUrl(text) {
    try {
        return ['http:', 'https:'].includes(new URL(text).protocol);
    } catch (error) {
        return false;
    }
}

/**
 * The same checks as the API (AttributeValueNormalizer) for the values typed by hand.
 */
export function isValidText(type, text) {
    switch (type) {
        case FIELD_TYPES.FLOAT:
            return NUMBER.test(text);
        case FIELD_TYPES.DATE:
            return isDate(text);
        case FIELD_TYPES.URL:
            return isUrl(text);
        default:
            return '' !== text.trim();
    }
}

/**
 * The value sent to the API for what the field holds.
 */
export function toApiValue(type, value) {
    switch (type) {
        case FIELD_TYPES.FLOAT:
            return Number(String(value).replace(',', '.'));
        case FIELD_TYPES.BOOL:
            return true === value || 'true' === value;
        default:
            return value;
    }
}
